<template>
  <div>
    <el-alert
      title="İcra Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste && !lo"
    >
    </el-alert>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste && !lo"
      row-key="id"
      :height="Height"
      @current-change="IcraSecim">
      <el-table-column
        label="Avukat">
        <template slot-scope="scope">
          {{ scope.row.Bilgi.Unvan }}
        </template>
      </el-table-column>
      <el-table-column
        label="İcra Tarihi"
        width="90">
        <template slot-scope="scope">
          {{ scope.row.Bilgi.iTarihText }}
        </template>
      </el-table-column>
      <el-table-column
        label="Dosya No"
        width="90">
        <template slot-scope="scope">
          {{ scope.row.Bilgi.dNo }}
        </template>
      </el-table-column>
      <el-table-column
        label="Anapara"
        align="right"
        width="90"
      >
        <template slot-scope="scope">
          {{ scope.row.Bilgi.AltTutar }}
        </template>
      </el-table-column>
      <el-table-column
        label="Zam"
        align="right"
        width="90"
      >
        <template slot-scope="scope">
          {{ scope.row.Bilgi.AltZam }}
        </template>
      </el-table-column>
      <el-table-column
        label="Ödenecek"
        align="right"
        width="90"
      >
        <template slot-scope="scope">
          {{ scope.row.Bilgi.AltToplam }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
import Yukleniyor from "../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Kisi_id"],
  data() {
    return {
      lo: true,
      Liste: null,
      Height: window.innerHeight - 215
    }
  },
  methods: {
    IcraSecim(val) {
      // console.log(val);
      this.$router.push('/icra/dosya/' + this.Kisi_id);
    },
    SayfaYukle() {
      if (this.Kisi_id) {
        this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/icra'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }
    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiIcra.vue